import type { TMessages } from '@/types/TMessages'

export const messages = {
  selectedMobile: 'Сортировать',
  selected: 'Сортировать: цена {sortOrder, select, fca {на складе} price {на элеваторе} fob {на борту судна} other {EXW}}',
} satisfies TMessages
